import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService.ts';
import './Login.css';

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [debugInfo, setDebugInfo] = useState<string | null>(null);

  useEffect(() => {
    // Check if this is a redirect back from authentication
    const checkRedirectResult = async () => {
      try {
        setIsLoading(true);
        console.log("Checking redirect result...");
        const user = await authService.getRedirectResult();
        console.log("Redirect result:", user ? "User authenticated" : "No redirect result");
        
        if (user) {
          console.log("Navigation to /admin");
          navigate('/admin');
        }
      } catch (error: any) {
        console.error('Login failed:', error);
        setError(error.message || 'Unauthorized access. Admin privileges required.');
        
        // Add debug information
        setDebugInfo(JSON.stringify({
          code: error.code,
          message: error.message,
          stack: error.stack?.split('\n').slice(0, 3).join('\n')
        }, null, 2));
      } finally {
        setIsLoading(false);
      }
    };

    checkRedirectResult();
  }, [navigate]);

  const handleGoogleLogin = async () => {
    try {
      setIsLoading(true);
      console.log("Initiating Google sign-in...");
      // Use redirect method instead of popup
      await authService.initiateGoogleSignIn();
      // The page will redirect to Google and then back to this page
    } catch (error: any) {
      console.error('Login initiation failed:', error);
      setError(error.message || 'Failed to start login process');
      
      // Add debug information
      setDebugInfo(JSON.stringify({
        code: error.code,
        message: error.message,
        stack: error.stack?.split('\n').slice(0, 3).join('\n')
      }, null, 2));
      
      setIsLoading(false);
    }
  };

  // Fallback to popup method if redirect is not working
  const handleGoogleLoginPopup = async () => {
    try {
      setIsLoading(true);
      console.log("Initiating Google sign-in with popup...");
      const user = await authService.signInWithGoogle();
      if (user) {
        navigate('/admin');
      }
    } catch (error: any) {
      console.error('Login failed:', error);
      setError(error.message || 'Unauthorized access. Admin privileges required.');
      
      // Add debug information
      setDebugInfo(JSON.stringify({
        code: error.code,
        message: error.message,
        stack: error.stack?.split('\n').slice(0, 3).join('\n')
      }, null, 2));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>Spontane Events</h1>
        <h2>Content Manager</h2>
        {error && <div className="error-message">{error}</div>}
        {debugInfo && (
          <div className="debug-info">
            <h3>Debug Information</h3>
            <pre>{debugInfo}</pre>
          </div>
        )}
        {isLoading ? (
          <div className="loading">Checking authentication...</div>
        ) : (
          <>
            <button className="google-login-button" onClick={handleGoogleLogin}>
              <img src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" alt="Google Logo" />
              Sign in with Google (Redirect)
            </button>
            <button className="google-login-button" onClick={handleGoogleLoginPopup} style={{ marginTop: '10px' }}>
              <img src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" alt="Google Logo" />
              Sign in with Google (Popup)
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;